import * as React from "react";
import { forwardRef } from "react";
const SvgZigTag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M21 12L21 9C21 7.89543 20.1046 7 19 7L5 7C3.89543 7 3 7.89543 3 9L3 13.4615L3 17C3 18.1046 3.89543 19 5 19L9.42857 19L12.6429 19L13.4464 19",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10 11L14 11L10 15L14 15",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M19.0195 14L21.5158 15.664L18.1878 20.6564L16.385 20.6565L15.6916 18.9925L19.0195 14Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgZigTag);
export default ForwardRef;
